import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-circle-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM239 142.1L103.5 277.6C94.1 287 94.1 302.2 103.5 311.5L120.5 328.5C129.9 337.9 145.1 337.9 154.4 328.5L256 226.9 357.6 328.5C367 337.9 382.2 337.9 391.5 328.5L408.5 311.5C417.9 302.1 417.9 286.9 408.5 277.6L273 142.1C263.6 132.7 248.4 132.7 239 142.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chevron-circle-up.js
// module id = 3KPY
// module chunks = 144